module.exports = __webpack_public_path__ + "static/media/q_w.3382a953.png";